/* eslint-disable max-statements */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface DownloadProvidedDocumentProps {
  declarationId: string;
  fileName: string;
}

export const useDownloadProvidedDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, fileName }: DownloadProvidedDocumentProps) => {
      const result = await apiClient.declarationsDocuments.downloadProvidedDocument.query({
        params: { id: declarationId, fileName },
      });

      if (result.status !== 200) throw result.body;

      const data = result.body as Blob;
      const contentDisposition = result.headers.get('content-disposition') ?? '';
      const href = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = href;
      const filename = /filename="([^"]*)"/.exec(contentDisposition)?.[1] || fileName;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
      return { data };
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading document!');
    },
  });
};
